import { Resource } from "@/api";
import { Button, Drawer } from "@/components";
import { DRAWER_RESOURCE } from "@/const";
import { useAppProperties } from "@/hooks";
import { FileBlank, FileDocument, Image02 } from "@/icons";
import { useResponsiveness, useTranslate } from "@/providers/context";
import { downloadFile } from "@/utils";

const VALID_TYPES = ["png", "jpg", "jpeg", "pdf"];

const ResourceItem = ({ resource }: { resource: Resource }) => {
  const { Title, Type, Url } = resource;
  return (
    <div
      onClick={() => downloadFile(Url)}
      className="p2-medium mb-5 flex h-[22px] w-fit cursor-pointer select-none items-center text-item-primary hover:text-highlightPrimary active:text-highlightSecondary"
    >
      <div className="mr-1">
        {Type === "pdf" ? (
          <FileBlank className="h-6 w-6" />
        ) : (
          <Image02 className="h-6 w-6" />
        )}
      </div>
      {Title}
    </div>
  );
};

interface ResourcesProps {
  resources?: Resource[];
}

export const ResourcesButton = ({ resources }: ResourcesProps) => {
  const { openDrawer, setOpenDrawer } = useResponsiveness();
  const { translate } = useTranslate();
  const { resourcesLabel } = useAppProperties();

  const validResources = resources?.filter((r) => VALID_TYPES.includes(r.Type));

  if (!validResources || validResources.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        variant="secondary"
        onClick={() => setOpenDrawer(DRAWER_RESOURCE)}
        size="s"
      >
        <FileDocument className="mr-1 h-5 w-5" />
        {translate(resourcesLabel)}
      </Button>
      <Drawer
        title={translate(resourcesLabel)}
        open={openDrawer === DRAWER_RESOURCE}
        onOpenChange={(open) => setOpenDrawer(open ? DRAWER_RESOURCE : "")}
      >
        {validResources?.map((r) => (
          <ResourceItem key={r.ResourceId} resource={r} />
        ))}
      </Drawer>
    </>
  );
};
